import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { FiLoader } from "react-icons/fi";
import { AuthContext } from "../context/AuthContext";
import { hasAnyRole, hasAnyPermission, hasFeatureGroup } from "../utils/roleUtils";
import { hasUiItemAccess } from "../utils/uiConfig";

const ProtectedRoute = ({
  allowedRoles,
  allowedPermissions,
  featureGroupKey,
  itemId,
  children,
}) => {
  const { user, uiConfig, loading, uiConfigLoading } = useContext(AuthContext);

  if (loading || uiConfigLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "var(--bg-primary)",
        }}
      >
        <FiLoader
          className="animate-spin"
          style={{ fontSize: "2rem", color: "var(--primary)" }}
        />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (Array.isArray(allowedRoles) && allowedRoles.length > 0 && !hasAnyRole(user, allowedRoles)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (Array.isArray(allowedPermissions) && allowedPermissions.length > 0 && !hasAnyPermission(user, allowedPermissions)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (featureGroupKey && !hasFeatureGroup(user, featureGroupKey)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (itemId && !hasUiItemAccess(uiConfig, itemId, user)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children || <Outlet />;
};

export default ProtectedRoute;
